
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "tax",
  "title": "Taxation",
  "sidebar_label": "Taxation"
};
const slug = 'tax';
const tableOfContents = [{
  "title": "Tax Feature",
  "slug": "tax-feature",
  "children": []
}, {
  "title": "Note: Marketplace",
  "slug": "note-marketplace",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"tax-feature"} nextElement={{
      "type": "paragraph"
    }}>Tax Feature</_Heading>
    <p>{`A Tax feature that allows accounts platform owners to set up and manage taxes for their listings. This feature provides a range of options and controls to help accounts comply with local tax laws and regulations.`}</p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/tax.png" />
      </div>
    <p>{`Using the Tax feature, accounts can:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add a title to the tax, such as `}<inlineCode parentName="li">{`Sales Tax`}</inlineCode>{` or `}<inlineCode parentName="li">{`VAT`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Set the default percentage rate for the tax.`}</li>
      <li parentName="ul">{`Use a short code to identify the tax, such as `}<inlineCode parentName="li">{`ST`}</inlineCode>{` or `}<inlineCode parentName="li">{`VAT`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Set whether the tax is inclusive or not. This determines whether the tax is included in the listed price of the listing or added on top of it.`}</li>
      <li parentName="ul">{`View and manage a list of all the taxes set up on the platform.`}</li>
    </ul>
    <p>{`The Tax feature is a useful tool for accounts to ensure that they are compliant with local tax laws and to provide a clear and transparent pricing structure for their customers. It can also help to streamline the tax management process and reduce the risk of errors or oversights.`}</p>
    <_Heading level={2} id={"note-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Note: Marketplace</_Heading>
    <p>{`Only marketplace owner can set the taxes and it is applied on Marketplace Platform level. `}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
